import {request} from "@/request";
import {message} from "ant-design-vue";

const Message = message;


export const actionType = [

  {
    action: 1,
    title: "新增/关联"
  },
  {
    action: 2,
    title: "删除/解除"
  },
  {
    action: 3,
    title: "停用"
  },
  {
    action: 4,
    title: "启用"
  },
]

export const typeListLim= [
  { dicId: 1, name: "丧失,时限：终生" },
  { dicId: 2, name: "撤销（品行不良、侮辱学生）,时限：5年" },
  { dicId: 3, name: "撤销（弄虚作假、骗取教师资格）,时限：5年" }
];


export const violationsTypeLim = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("viewBaseDictByDictType", {dtId: 2001}).then(res => {

      const temp = [];
      res.record.forEach(element => {
        if (element.code.length === 2) {
          temp.push(element);
        }
      });
      resolve(temp);
    });
  });
};

let violationsLimTemp=[];

export const violationsLim = (that, params) => {
  if(!params || !params.pId){
    return;
  }
  return new Promise((resolve, reject) => {
    that.$json("viewBaseDictByDictType", {dtId: 2001}).then(res => {

      const pCode = res.record.filter(f=>f.dicId===params.pId)[0].code;

      const temp = [];
      res.record.forEach(element => {
        if (element.code.length === 4 && element.code.indexOf(pCode) === 0) {
          temp.push(element);
        }
      });
      violationsLimTemp = temp;
      resolve(temp);
    });
  });
};

export const violationsReasonLim = (that, params) => {
  if(!params || !params.pId){
    return;
  }
  return new Promise((resolve, reject) => {
    that.$json("queryDictByDictTypeBasic", {dtId: 2002}).then(res => {

      const pCode = violationsLimTemp.filter(f=>f.dicId===params.pId)[0].code;

      const temp = [];
      res.record.forEach(element => {
        if (element.code.indexOf(pCode) === 0) {
          temp.push(element);
        }
      });
      resolve(temp);

    });
  });
};

export const loseTypeLim = [
  {dicId: "1", name: "刑事处罚"},
  {dicId: "2", name: "行政处罚"}
];

export const statusLim = [
  {dicId: "0", name: "待审批"},
  {dicId: "1", name: "审批通过"},
  {dicId: "2", name: "审批不通过"},
];

export const accessDecision = [
  {dicId: "10", name: "待查询"},
  {dicId: "11", name: "查询中"},
  {dicId: "0", name: "未返回"},
  {dicId: "1", name: "已返回"}
];


export const status = [
  //{ dicId: 0, name: "所有" },
  {dicId: 1, name: "启用"},
  {dicId: 2, name: "停用"}
];
export const handleStatus = [
  {
    type: 1,
    title: "待审核"
  },
  {
    type: 0,
    title: "审核通过"
  },
  {
    type: -1,
    title: "审核不通过"
  }
]
// 注册 确认状态
export const applicationConditionList = [
  {dicId: '0', name: "申报未受理"},
  {dicId: '21', name: "材料齐全"},
  {dicId: '24', name: "材料不全"},
  {dicId: '6', name: "网报待确认"},
]

export const sortRule = [
  {dicId: "1", name: "报名号升序排列"},
  {dicId: "2", name: "报名号降序排列"},
  {dicId: "3", name: "档案号升序排列"},
  {dicId: "4", name: "档案号降序排列"},
  {dicId: "5", name: "身份证号升序排列"},
  {dicId: "6", name: "身份证号降序排列"},
  {dicId: "7", name: "教师资格种类顺序排列"},
  {dicId: "8", name: "确认点 (A-Z)"},
  {dicId: "9", name: "毕业学校 (A-Z)"},
  {dicId: "10", name: "工作单位 (A-Z)"},
  {dicId: "11", name: "网报时间段升序排列"},
  {dicId: "12", name: "网报时间段隆序排列"},
]
export const deleteStatus = [
  {dicId: "0", name: "正常"},
  {dicId: "1", name: "已受限"},
  {dicId: "2", name: "被删除"}
]

// export const certDeleteStatus = [
//   {dicId: "0", name: "正常"},
//   {dicId: "1", name: "被限制"},
//   {dicId: "2", name: "被删除"}
// ]


export const enrDeleteStatus = [
  {dicId: "0", name: "正常"},
  {dicId: "1", name: "已受限"},
  {dicId: "2", name: "被删除"},
  {dicId: "3", name: "注册无效"}
]

export const accessStatus = [
  {dicId: "10", name: "待查询"},
  {dicId: "11", name: "查询中"},
  {dicId: "0", name: "正常"},
  {dicId: "1", name: "有判决信息"},
  {dicId: "2", name: "有起诉信息"},
  {dicId: "3", name: "有相对不起诉信息"},
  {dicId: "4", name: "有违法信息"}
]

export const allowQueryStatus = [
  {dicId: "0", name: "未提供"},
  {dicId: "1", name: "已提供"},
]

// export const ctId = [
//   {dicId: "1", name: "幼儿园教师资格"},
//   {dicId: "2", name: "小学教师资格"},
//   {dicId: "3", name: "初级中学教师资格"},
//   {dicId: "4", name: "高级中学教师资格"},
//   {dicId: "5", name: "职业中学教师资格"},
//   {dicId: "6", name: "职业中学实习指导教师资格"},
//   {dicId: "7", name: "高等学校教师资格"}
// ]


export const ctId = (that, params = {}) => {
  return new Promise((resolve, reject) => {
    that.$json("getCertTypeListBasic", params).then(res => {
      resolve(res.record);
    });
  });
};


export const regstatus = [
  {dicId: "0", name: "申报未受理"},
  {dicId: "6", name: "网报待确认"},
  {dicId: "9", name: "确认未通过"},
  {dicId: "15", name: "待审批"},
  {dicId: "18", name: "审批通过待编号"},
  {dicId: "21", name: "认定通过"},
  {dicId: "24", name: "认定未通过"}
]

export const exam = [
  {dicId: "2", name: "免试认定"},
  {dicId: "1", name: "统考"},
  {dicId: "0", name: "非统考"}
]

export const auth = [
  {dicId: "0", name: "未实名"},
  {dicId: "1", name: "核验通过"},
  {dicId: "2", name: "核验未通过"},
  {dicId: "3", name: "待人工审核"},
  {dicId: "4", name: "人工审核通过"},
  {dicId: "5", name: "人工审核未通过"}
]

export const TeacherSubject = {
  1: "幼儿园任教学科管理",
  2: "小学任教学科管理",
  3: "初中任教学科管理",
  4: "高中任教学科管理",
  5: "中职中专任教学科管理",
  66: "高校任教学科管理"
}
// 基础数据 确认点查询
export const orgBizTypeList = [
  {dicId: 1, name: "参与认定"},
  {dicId: 2, name: "参与注册"},
  // { dicId: 3, name: "全部参与" }
]
export const typeList = [
  {dicId: 1, name: "确认机构"},
  {dicId: 2, name: "县级机构"},
  {dicId: 3, name: "市级机构"},
  {dicId: 4, name: "省级机构"},
  {dicId: 5, name: "资格中心"}
]

//USBK 状态
export const statusList = [
  {dicId: 1, name: "未分配"},
  {dicId: 2, name: "正常"},
  {dicId: 3, name: "作废"},
  {dicId: 4, name: "锁定"}
]
 //犯罪记录核查
export const moralityList = [
  {dicId: 0, name: "无犯罪记录"},
  {dicId: 1, name: "有犯罪记录，可认定"},
  {dicId: 2, name: "有犯罪记录，不可认定"}
]

//是否准入查询

export const accessStatusList = [
  { dicId: "10", name: "待查询" },
  { dicId: "11", name: "查询中" },
  { dicId: "0", name: "正常" },
  { dicId: "1", name: "有判决信息" },
  { dicId: "2", name: "有起诉信息" },
  { dicId: "3", name: "有相对不起诉信息" },
  { dicId: "4", name: "有违法信息" }
]

//准入查询状态
export const accessStatusMergeList=  [
  { dicId: "10", name: "待查询" },
  { dicId: "11", name: "查询中" },
  { dicId: "0", name: "正常" },
  { dicId: "1", name: "有性侵违法犯罪信息" }
]

export const addTypeList=  [
  { dicId: "1", name: "补发" },
  { dicId: "2", name: "换发" }
]

export const printList=  [
  { dicId: "0", name: "未打印" },
  { dicId: "1", name: "已打印" },
  { dicId: "2", name: "打印重置" }
]



// 数据来源
export const dataFrom = [
  {dicId: "99", name: "2012年之前认定" },
  {dicId: "0", name: "网上申报"},
  {dicId: "1", name: "后台采集"},
  {dicId: "2", name: "定期注册"},
  {dicId: "3", name: "单机版导入"},
  {dicId: "4", name: "未入库的认定信息变更"},
  {dicId: "5", name: "广西导入" },
  {dicId: "6", name: "补发换发入库" },
  {dicId: "7", name: "限制库入库" }
]

export const enrollDataFrom = [
  {dicId: "0", name: "网上申报"},
  {dicId: "1", name: "后台采集"},
  {dicId: "2", name: "后台导入" }
]

export const  dataFromList= [
  { code: "99", name: "2012年之前认定" },
  { code: "0", name: "网上申报" },
  { code: "1", name: "后台采集" },
  { code: "2", name: "定期注册入库" },
  { code: "3", name: "单机版导入" },
  { code: "4", name: "未入库历史数据变更" },
  { code: "5", name: "广西导入" },
  { code: "6", name: "补发换发入库" },
  { code: "7", name: "限制库入库" },
]
export const sex = [
  {dicId: '1', name: '男'},
  {dicId: '2', name: '女'}
]

export const normalSex = [
  {dicId: '男', name: '男'},
  {dicId: '女', name: '女'}
]

export const normalEduLevel = [
  {dicId: "4", name: "专科",},
  {dicId: "3", name: "本科",},
  {dicId: "2", name: "硕士研究生",},
  {dicId: "1", name: "博士研究生",}
]

export const qrStatus= [
  {dicId: '0', name: '申报未受理'},
  {dicId: '6', name: '网报待确认'},
  {dicId: '9', name: '确认未通过'},
  {dicId: '15', name: '确认通过'}
]
export const changeStatusList=[
  { dicId: '2', name: "证书变更" },
  { dicId: '10', name: "证书删除" },
  { dicId: '11', name: "证书恢复" },
  { dicId: '12', name: "补添证书" },
]

export const changeStatus=[
  { dicId: '1', name: "待审批" },
  { dicId: '8', name: "审核不通过" },
  { dicId: '9', name: "审核通过" }
]

export const spStatus= [
  {dicId: '15', name: '待审批'},
  {dicId: '18', name: '审批通过待编号'},
  {dicId: '21', name: '认定通过'},
  {dicId: '24', name: '认定未通过'}
]

export const isExitsChange = [
  {dicId: 1, name: "有"},
  {dicId: 2, name: "无"},

]
// 「报名号、档案号、证书号码流水号、身份证号、教师资格种类考试类型、确认点、毕业学校、工作单位（A-Z）、网报时间

export const regOrderList = [
  { dicId: "reg_id", name: "报名号" },
  { dicId: "ARCHIVE_NO", name: "档案号" },
  { dicId: "CERT_NO", name: "证书号码" },
  { dicId: "ID_NO", name: "身份证号" },
  { dicId: "CT_ID", name: "教师资格种类" },
  { dicId: "EXAM", name: "考试类型" },
  { dicId: "LOCALE_ID", name: "确认点" },
  { dicId: "WORK_UNITS", name: "工作单位" },
  { dicId: "TEMP_SCHOOL", name: "毕业学校" },
  { dicId: "obt_id", name: "网报时间段" },
  { dicId: "last_modify", name: "报名信息更新时间" },
  { dicId: "webUpdateTime", name: "网办材料更新时间" },
]




export const enrollOrderList = [
  { dicId: "ENR_ID", name: "报名号" },
  { dicId: "ARCHIVE_NO", name: "档案号" },
  { dicId: "CERT_NO", name: "证书号码" },
  { dicId: "WORK_UNIT", name: "现任教学校" },
  { dicId: "TEA_GRADE", name: "现任教学段" },
  { dicId: "TEA_SUBJECT", name: "现任教学科" },
  { dicId: "CT_ID", name: "资格种类" },
  { dicId: "ID_NO", name: "证件号码" },
  { dicId: "obt_id", name: "网报时间段" },
  { dicId: "LOCALE_ID", name: "确认点" }
]
//报名号
// 档案号
// 身份证号
// 教师资格种类
// 确认点（
// 现任教学校
// 岗位性质
// 网报时间
// 注册结论顺序排序
export const enrollHisOrderList= [
  { dicId: "ENR_HIS_ID", name: "报名号" },
  { dicId: "ARCHIVE_NO", name: "档案号" },
  { dicId: "CERT_NO", name: "证书号码" },
  { dicId: "ID_NO", name: "身份证号" },
  { dicId: "CT_ID", name: "教师资格种类" },
  { dicId: "LOCALE_ID", name: "确认点" },
  { dicId: "WORK_UNIT", name: "现任教学校" },
  { dicId: "postQuale", name: "岗位性质" },
  { dicId: "obt_id", name: "网报时间" },
  { dicId: "JUDGMINT_STATUS", name: "注册结论" }
]

// 证书变更  2
// 证书删除  10
// 证书恢复  11
// 补添证书  12
//
// 注册历史数据撤销 5
// 注册历史数据结论变更 9
export const chgCerttypeList= [
  { dicId: "2", name: "证书变更" },
  { dicId: "10", name: "证书删除" },
  { dicId: "11", name: "证书恢复" },
  { dicId: "12", name: "补添证书" },
  { dicId: "5", name: "注册历史数据撤销" },
  { dicId: "9", name: "注册历史数据结论变更" },
]

export const baStatusList = [
  { dicId: "1", name: "已备案" },
  { dicId: "2", name: "备案申请" },
  { dicId: "3", name: "备案不通过" },
]
export const baDocTypeList = [
  { dicId: "1", name: "认定数据导出授权申请" },
  { dicId: "2", name: "注册数据导出授权申请" },
  // { dicId: "3", name: "认定及注册数据导出授权申请" }
]


export const orderDescList = [
  {dicId: "asc", name: "升序"},
  {dicId: "desc", name: "降序"},
]

//regWebTransactList
export const regWebTransactList = [
  {dicId:'1', name: "全程网办"},
  {dicId: '0', name: "线下确认"},
  // {dicId: '2', name: "同时开展全程网办及线下确认"},
]






export const DicType = [
  {
    name: "个人信息",
    code: "userInfo",
    children: [
      {
        dtId: 10,
        code: "idType",
        name: "证件类型",
      },
      {
        dtId: 5,
        code: "nation",
        name: "民族",
      },
      {
        dtId: 3,
        code: "political",
        name: "政治面貌",
      },
      {
        dtId: 4,
        code: "occupation",
        name: "从事职业",
      },
      {
        dtId: "getTechnicalJobDataBasic",
        code: "major",
        name: "专业技术职务",
      },
    ]
  },
  {
    name: "学历、学籍和能力信息",
    code: "educationteachInfo",
    children: [
      {
        dtId: "queryCollegesBasic",
        code: "graduateSchool",
        name: "毕业学校",
      },
      {
        dtId: 30,
        code: "SchoolRunType",
        name: "（毕业学校）办学类型",
      },
      {
        dtId: 7,
        code: "eduLevel",
        name: "最高学历",
      },
      {
        dtId: 6,
        code: "degree",
        name: "最高学位",
      },
      {
        dtId: "queryMajorsBasic",
        code: "MajorStudied",
        name: "所学专业",
      },
      {
        dtId: 2,
        code: "majorType",
        name: "专业类别",
      },
      {
        dtId: 14,
        code: "suspensionCourse",
        name: "修学课程",
      },
      {
        dtId: 21,
        code: "learnType",
        name: "学历类别",
      },
      {
        dtId: 212,
        code: "learnType2",
        name: "学习形式",
      },
      {
        dtId: 41,
        code: "studentStatus",
        name: "学籍状态",
      },
      {
        dtId: 42,
        code: "graduateStatus",
        name: "毕业结论",
      },
      {
        dtId: 9,
        code: "pthLevel",
        name: "普通话等级",
      },
    ]
  },
  {
    name: "任教信息",
    code: "teachInfo",
    children: [
      {
        dtId: "querySubject1",
        code: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType?type=1",
        component: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType",
        code2: "BaseSubjectSubModel",
        id: "1",
        name: "幼儿园任教学科管理",
        order: 0,
        parentId: "10022",
        parentMenu: "/basicModel/BaseSubjectSubModel",
        title: "幼儿园任教学科管理",
        url: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType"
      },
      {
        dtId: "querySubject2",
        code: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType?type=2",
        component: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType",
        code2: "BaseSubjectSubModel",
        id: "2",
        name: "小学任教学科管理",
        order: 0,
        parentId: "10022",
        parentMenu: "/basicModel/BaseSubjectSubModel",
        title: "小学任教学科管理",
        url: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType"
      },
      {
        dtId: "querySubject3",
        code: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType?type=3",
        component: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType",
        code2: "BaseSubjectSubModel",
        id: "3",
        name: "初中任教学科管理",
        order: 0,
        parentId: "10022",
        parentMenu: "BaseSubjectSubModel",
        title: "初中任教学科管理",
        url: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType"
      },
      {
        dtId: "querySubject4",
        code: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType?type=4",
        component: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType",
        code2: "BaseSubjectSubModel",
        id: "4",
        name: "高中任教学科管理",
        order: 0,
        parentId: "10022",
        parentMenu: "BaseSubjectSubModel",
        title: "高中任教学科管理",
        url: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType"
      },
      {
        dtId: "querySubject5",
        code: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType?type=5",
        component: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType",
        code2: "BaseSubjectSubModel",
        id: "5",
        name: "中职中专任教学科管理",
        order: 0,
        parentId: "10022",
        parentMenu: "BaseSubjectSubModel",
        title: "中职中专任教学科管理",
        url: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType"
      },
      {
        dtId: "querySubject66",
        code: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType?type=77",
        component: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType",
        code2: "BaseSubjectSubModel",
        id: "66",
        name: "高校任教学科管理",
        order: 0,
        parentId: "10022",
        parentMenu: "BaseSubjectSubModel",
        title: "高校任教学科管理",
        url: "/basicModel/BaseSubjectSubModel/BaseSubjectSubModelType"
      },

      {
        dtId: 23,
        code: "teachFrade",
        name: "任教学段",
      },
      {
        dtId: 22,
        code: "workUnitType",
        name: "任教学校所在地",
      },
      {
        dtId: 25,
        code: "schoolQuale",
        name: "（任教）学校性质",
      },
      {
        dtId: 24,
        code: "jobPost",
        name: "岗位性质",
      },
    ]
  },
  /*{
    name:"任教学科",
    code:"teachSubject",
    children:[
      {
        dtId:'querySubject',
        code:"kinderteachSubject",
        name:"幼儿园任教学校",
      },
      {
        dtId:'querySubject',
        code:"primaryteachSSubject",
        name:"小学任教学科",
      },
      {
        dtId:'querySubject',
        code:"juniorhighteachSSubject",
        name:"初中任教学科",
      },
      {
        dtId:'querySubject',
        code:"highteachSSubject",
        name:"高中任教学科",
      },
      {
        dtId:'querySubject',
        code:"SecondaryteachSSubject",
        name:"中职中专任教学科",
      },
      {
        dtId:'querySubject',
        code:"highSchoolteachSSubject",
        name:"高校任教学科",
      },
    ]
  },*/
  /*{
    name:"省份",
    code:"province",
    children:[

    ]
  },*/
  {
    name: "资格种类",
    code: "QualificationType",
    children: [
      {
        dtId: "getCertTypeListBasic",
        code: "QualificationType",
        name: "资格种类",
      },
      /*{
        dtId:"queryBaseCertTypeLinkBasic",
        code:"QualificationTypeEducation",
        name:"资格种类关联学历",
      },*/
    ]
  },
  {
    name: "免试认定信息",
    code: "免试认定信息",
    children: [
      {
        dtId: "51",
        code: "专业培养目标",
        name: "专业培养目标",
      },
      {
        dtId: "52",
        code: "教育实习实践组织方式",
        name: "教育实习实践组织方式",
      },
      {
        dtId: "53",
        code: "教育实习实践地点",
        name: "教育实习实践地点",
      },
      {
        dtId: "54",
        code: "面试考核组织方式",
        name: "面试考核组织方式",
      },
      {
        dtId: "55",
        code: "领导成员类型",
        name: "领导成员类型",
      },
    ]
  },
  {
    name: "认定申请人报名信息",
    code: "认定申请人报名信息",
    children: [
      {
        dtId: "1001",
        code: "普通话核验省份字典",
        name: "普通话核验省份字典",
      },
      {
        dtId: "1002",
        code: "国办接口",
        name: "国办接口",
      },
      {
        dtId: "61",
        code: "网报材料类型",
        name: "网报材料类型",
      },
    ]
  },
  {
    name: "限制库",
    code: "限制库",
    children: [
      {
        dtId: "2001",
        code: "违法违规类型",
        name: "违法违规类型",
      },
      {
        dtId: "2002",
        code: "教育行政处罚原因",
        name: "教育行政处罚原因",
      },
      {
        dtId: "2003",
        code: "任教学段",
        name: "任教学段",
      },
      {
        dtId: "2005",
        code: "资格种类",
        name: "资格种类",
      },
    ]
  },
  {
    name: "客户端",
    code: "客户端",
    children: [
      {
        dtId: "2004",
        code: "客户端版本号",
        name: "客户端版本号",
      }
    ]
  }
]



export const idType = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("queryDictByDictTypeBasic", params).then(res => {
      resolve(res.record);
    });
  });
};


export const getTeacherScores = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("getTeacherScores", params).then(res => {
      resolve(res.record);
    });
  });
};





export const nation = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("queryDictByDictTypeBasic", params).then(res => {
      resolve(res.record);
    });
  });
};

//专业类别
export const normalMajor = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("queryDictByDictTypeBasic", params).then(res => {
      resolve(res.record);
    });
  });
};

//普通话
export const pthLevelList = (that, params) => {
  params["status"] =1;
  params["dtId"] =9;
  return new Promise((resolve, reject) => {
    that.$json("queryDictByDictTypeBasic", params).then(res => {
      resolve(res.record);
    });
  });
};


export const learnTypeList = (that, params) => {
  params["status"] =1;
  params["dtId"] =21;
  return new Promise((resolve, reject) => {
    that.$json("queryDictByDictTypeBasic", params).then(res => {
      resolve(res.record);
    });
  });
};

//学历
export const eduLevel = (that, params) => {
  params["status"] =1;
  params["dtId"] =7;
  return new Promise((resolve, reject) => {
    that.$json("queryDictByDictTypeBasic", params).then(res => {
      resolve(res.record);
    });
  });
};

// 学位
export const degreeLevel = (that, params) => {
  params["status"] =1;
  params["dtId"] =6;
  return new Promise((resolve, reject) => {
    that.$json("queryDictByDictTypeBasic", params).then(res => {
      resolve(res.record);
    });
  });
};
// 专业培养目标
export const trainTARGET = (that, params) => {
  params["status"] =1;
  params["dtId"] =51;
  return new Promise((resolve, reject) => {
    that.$json("queryDictByDictTypeBasic", params).then(res => {
      resolve(res.record);
    });
  });
};

export const CertType = (that, params = {}) => {
  return new Promise((resolve, reject) => {
    that.$json("getCertTypeListBasic", params).then(res => {
      resolve(res.record);
    });
  });
};


export const queryRole = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("queryRole", params).then(res => {
      resolve(res.record);
    });
  });
};



export const queryCertBatch = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("queryCertBatchxx", params).then(res => {
      let arr = res.record.map(item => {
        let obj = {
          id: item.cbId,
          name: item.cbName,

        };
        return obj;
      });
      resolve(arr);
    });
  });
};

//免试批次
export const queryNormalBatch = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("queryNormalBatch", params).then(res => {
      let arr = res.record.map(item => {
        let obj = {
          id: item.dicId,
          name: item.name,

        };
        return obj;
      });
      resolve(arr);
    });
  });
};



//国考批次
export const queryScoreBatch = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("queryScoreBatch", params).then(res => {
      let arr = res.record.map(item => {
        let obj = {
          id: item.code,
          name: item.name,
        };
        return obj;
      });
      resolve(arr);
    });
  });
};

export const subject = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("querySubjectBasic", params).then(res => {
      let arr = [];
      if (res.record && res.record.length > 0) {
        arr = res.record.map(item => {
          let obj = {
            id: item.subjectId,
            pId: item.parentId ? item.parentId : null,
            value: item.subjectId,
            title: item.name
          };
          return obj;
        });
      }
      resolve(arr);
    });
  });
};


export const teaSubject = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("querySubjectBasic", params).then(res => {
      let arr = [];
      if (res.record && res.record.length > 0) {
        arr = res.record.map(item => {
          let obj = {
            id: item.subjectId,
            pId: item.parentId ? item.parentId : null,
            value: item.subjectId,
            title: item.name
          };
          return obj;
        });
      }
      resolve(arr);
    });
  });
};



const getSubjectTree = (data,parentId,level = 1,key) =>{
  // let arr = [];
  if(level == 1){
    return data.filter(v => !v.parentId).map(v => ({
      ...v,
      children: getSubjectTree(data, v[key], level + 1,key),
    }));
  }else if(data.some(v => v.parentId == parentId)){

    return data
      .filter(v => v.parentId === parentId)
      .map(v =>
        level === 4
          ? {
            ...v
          }
          : {
            ...v,
            children: getSubjectTree(data, v[key], level + 1,key),
          }
      );

  }
}


export const allSubjectSearch = (that, params = {}) => {
  return new Promise((resolve, reject) => {
    params["status"] =1;
    params["noPage"] =1;
    that.$json("querySubjectsBasic", params).then(res => {
      let list = getSubjectTree(res.record,'',1,'subjectId');
      let arr = [];
      if (list&& list.length > 0) {
        arr = list.map(item => {
          let obj = {
            id: item.subjectId,
            pId: item.parentId ? item.parentId : null,
            value: item.subjectId,
            title: item.name
          };
          return obj;
        });
      }
      resolve(arr);

    });
  });
};

//所有学科
export const allSubject = (that, params = {}) => {
  return new Promise((resolve, reject) => {
    // params["status"] =1;
    params["noPage"] =1;
    that.$json("querySubjectsBasic", params).then(res => {
      let list = getSubjectTree(res.record,'',1,'subjectId');
      console.log(list);
      resolve(list);
      // resolve(res.record);
    });
  });
};



// 查询高校信息
export const queryColleges = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("queryCollegesBasic", params).then(res => {
      // debugger;
      let collegeList = res.record;
      if (collegeList) {
        collegeList.map((item) => {
          item.name = item.name
          item.dicId = item.collegeId
        })
      }
      resolve(collegeList);

      // resolve(res.record);
    });
  });
};

//查询专业信息
export const queryMajors = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("queryMajorsBasic", params).then(res => {
      let collegeList = res.record;
      if (collegeList) {
        let list = getSubjectTree(collegeList,'',1,'majorId');
        resolve(list);
        // collegeList.map((item) => {
        //   item.name = item.name
        //   item.dicId = item.majorId
        // })
      }


      // resolve(res.record);
    });
  });
};
// export const queryMajors = (that, params) => {
//   return new Promise((resolve, reject) => {
//     that.$json("queryMajorsBasic", params).then(res => {
//       let collegeList = res.record;
//       if (collegeList) {
//         collegeList.map((item) => {
//           item.name = item.name
//           item.dicId = item.majorId
//         })
//       }
//       resolve(collegeList);
//
//     });
//   });
// };




// 资格证书信息列表
export const querySsoUserAllCerts = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("querySsoUserAllCerts", params).then(res => {
      resolve(res.record);
    });
  });
};


export const queryLimitation = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("queryLimitation", params).then(res => {
      resolve(res.record);
    });
  });
};

// 国考信息列表
export const queryScore = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("queryScore", params).then(res => {
      resolve(res.record);
    });
  });
};

//免试认定信息
export const queryNormalPreServiceTeacherByApplyer = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("queryNormalPreServiceTeacherByApplyer", params).then(res => {
      resolve(res.record);
    });
  });
};


// 普通话信息列表
export const querySsouserPthCert = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("querySsouserPthCert", params).then(res => {
      resolve(res.record);
    });
  });
};


// 学历信息列表
export const querySsouserCollegeCert = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("querySsouserCollegeCert", params).then(res => {
      resolve(res.record);
    });
  });
};


//学籍信息
export const queryScoreByApplyer = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("queryScoreByApplyer", params).then(res => {
      resolve(res.record);
    }).catch(error => {
      resolve([]);
      // reject(error.message);
    });
  });
};


// 学籍信息列表
export const querySsouserStudent = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("querySsouserStudent", params).then(res => {
      resolve(res.record);
    });
  });
};


// 学位信息列表
export const querySsouserDegreeCert = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("querySsouserDegreeCert", params).then(res => {
      resolve(res.record);
    });
  });
};


// 证书注册信息
export const certEnrollHistoryInfo = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("certEnrollHistoryInfo", params).then(res => {
      resolve(res.record);
    });
  });
};

//查询信息变更项
export const queryChangeBySource = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("queryChangeBySource", params).then(res => {
      resolve(res.record);
    });
  });
};


// 通过认定编号查询认定审批信息
export const queryRegAudByRegId = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("queryRegAudByRegId", params).then(res => {
      resolve(res.record);
    });
  });
};





export const getCurrentOrgBatchEnrollTimes = (that, params) => {
  return new Promise((resolve, reject) => {
    that.$json("getCurrentOrgBatchEnrollTimes", params).then(res => {

        let obtList1 = res.record;
        if (obtList1) {
          console.log(obtList1);
          obtList1.map((item) => {
            if (item.validEndDateStr != null) {
              item.name = item.validBeginDateStr + "至" + item.validEndDateStr
            } else {
              item.name = item.validBeginDateStr
            }
            item.dicId = item.obtId
          })
        }
        resolve(obtList1);

      resolve(res.record);
    }).catch(error => {
      if(error.code){
        resolve([]);
      }
    });
  });
};


export const getProvinceBasic = (that, params) => {
  return new Promise((resolve, reject) => {
    const uri = "getProvincesBasic";
    that.$json(uri, params).then(response => {
      resolve(response.record);
    });
  });
};


export const getProvinceBasic2 = (that, params) => {
  return new Promise((resolve, reject) => {
    const uri = "getProvincesBasic";
    that.$json(uri, params).then(response => {
      console.log(response.record)
      let list = response.record.map((item,index) =>{
        let obj = {
          dicId : item.PROVINCEID,
          name :  item.PROVINCENAME
        }
        return obj;
      })
      console.log(list);
      resolve(list);
    });
  });
};





export const queryBaseOrgBasic = (that, params) => {
  return new Promise((resolve, reject) => {
    const uri = "queryBaseOrgBasic";
    that.$json(uri, params).then(response => {
      resolve(response.record);
    });
  });
};


export const ecertSwitchs = [
  {dicId: "1", name: "参与"},
  {dicId: "0", name: "待参与"}
]

export const stampStatus = [
  {dicId: "1", name: "使用中"},
  {dicId: "0", name: "已停用"}
]



export const certStatus = [
  {dicId: "1", name: "生效中"},
  {dicId: "0", name: "撤销"}
]

// 撤销，吊销， 注销，挂失，过期，其它
export const certChangeStatus = [
  {dicId: "撤销", name: "撤销"},
  {dicId: "吊销", name: "吊销"},
  {dicId: "注销", name: "注销"},
  {dicId: "挂失", name: "挂失"},
  {dicId: "其它", name: "其它"},
]

export const orgAccessStatus = [
  {dicId: "1", name: "是"},
  {dicId: "0", name: "否"}
]


export const leavingAMessageList = [
  {dicId: "0", name: "未阅读"},
  {dicId: "1", name: "已阅读"}
]

export const zshmwsList = [
  {dicId: "0", name: "显示不规范位数"},
  {dicId: "1", name: "显示规范位数(15或17位)"}
]

export const orgtype = [

  {dicId: "4", name: "省级机构"},
  {dicId: "3", name: "市级机构"},
  {dicId: "2", name: "县级机构"}
]

export const bseOrgtype = [
  {dicId: "5", name: "教育部"},
  {dicId: "4", name: "省级机构"},
  {dicId: "3", name: "市级机构"},
  {dicId: "2", name: "县级机构"}
]

export const reviewStatusList = [
  {dicId: "30", name: "待初审"},
  {dicId: "31", name: "初审合格"},
  {dicId: "36", name: "申报未受理"},
  {dicId: "32", name: "初审暂缓注册"},
  {dicId: "33", name: "初审不合格"},
  // {dicId: "24", name: "初审材料不全"},
  {dicId: "35", name: "初审不在注册范围"},
  {dicId: "34", name: "初审无教师资格"}
]
export const reCheckStatusList = [
  {dicId: "40", name: "待复核"},
  {dicId: "41", name: "复核合格"},
  {dicId: "42", name: "复核暂缓注册"},
  {dicId: "43", name: "复核不合格"},
  {dicId: "45", name: "复核不在注册范围"},
  {dicId: "44", name: "复核无教师资格"}
]

export const judgmintStatusList = [
  {dicId: "50", name: "待终审"},
  {dicId: "51", name: "注册合格"},
  {dicId: "52", name: "暂缓注册"},
  {dicId: "53", name: "注册不合格"},
  {dicId: "55", name: "不在注册范围"},
  {dicId: "54", name: "无教师资格"}
]


export const cszcztList = [
  {dicId: "15", typeStr: "待初审"},
  {dicId: "19", typeStr: "初审合格"},
  {dicId: "0", typeStr: "申报未受理"},
  {dicId: "27", typeStr: "初审暂缓注册"},
  {dicId: "20", typeStr: "初审不合格"},
  {dicId: "24", typeStr: "初审材料不全"},
  {dicId: "14", typeStr: "初审不在注册范围"},
  {dicId: "28", typeStr: "初审无教师资格"}
]
export const fhzcztList = [
  {dicId: "15", typeStr: "待复核"},
  {dicId: "19", typeStr: "复核合格"},
  {dicId: "27", typeStr: "复核暂缓注册"},
  {dicId: "20", typeStr: "复核不合格"},
  {dicId: "14", typeStr: "复核不在注册范围"},
  {dicId: "28", typeStr: "复核无教师资格"}
]

export const zszcztList = [
  {dicId: "15", typeStr: "待终审"},
  {dicId: "19", typeStr: "注册合格"},
  {dicId: "27", typeStr: "暂缓注册"},
  {dicId: "20", typeStr: "注册不合格"},
  {dicId: "14", typeStr: "不在注册范围"},
  {dicId: "28", typeStr: "无教师资格"}
]
// 证书 变更状态
export const statuList = [
  {dicId: "1", name: "待审核"},
  {dicId: "8", name: "审核不通过"},
  {dicId: "9", name: "审核通过"},
]
// 证书 实名核验状态
export const smshztList = [
  {dicId: "0", name: "未实名"},
  {dicId: "1", name: "核验通过"},
  {dicId: "2", name: "核验未通过"},
  {dicId: "3", name: "待人工审核"},
  {dicId: "4", name: "人工审核通过"},
  {dicId: "5", name: "人工审核未通过"}
]
// 证书 确认状态
export const qrztList = [
  {dicId: "6", name: "待确认"},
  {dicId: "204", name: "暂存"},
  {dicId: "201", name: "确认通过（待初审）"},
  {dicId: "9", name: "确认不通过"}
]

export const qrtjjList = [
  {dicId: "0", name: "师德表现证明不具备"},
  {dicId: "1", name: "5年的年度考核不具备"},
  {dicId: "2", name: "省级教育行政部门认可的教育培训证明不具备"},
  {dicId: "3", name: "聘用合同或录用通知不具备"},
  {dicId: "4", name: "与任教岗位相应的教师资格证书不具备"},
  {dicId: "5", name: "省级以上教育行政部门规定的其他条件不具备"}
]


export const zctjList = [
  {dicId: "2", name: "遵纪守法和师德考核情况：不合格"},
  // {dicId: "3", name: "注册周期内年度考核情况：连续两年不合格"},
  {dicId: "4", name: "逾期未注册：是"},
  {dicId: "5", name: "是否撤销教师资格：是"},
  {dicId: "6", name: "是否丧失教师资格：是"},
  {
    dicId: "1",
    name: "与任教岗位相应的教师资格:依法获取的证书不符合要求"
  },
  {dicId: "7", name: "聘用合同或录用通知:无"},
  {dicId: "8", name: "注册周期内年度考核情况：单年度不合格"},
  {dicId: "9", name: "培训学时情况：不合格"},
  {
    dicId: "11",
    name:
      "一个注册周期内是否擅自中止教育教学和教育管理工作一学期及以上：是"
  },
  {dicId: "10", name: "是否具备省级教育行政部门规定的其他条件：否"},
  // {dicId: "12", name: "教师资格:无"}
]

//    复核状态	RE_CHECK_STATUS
//    终审状态	JUDGMINT_STATUS
//    确认状态	CONFIRM_STATUS
//    初审状态：19-初审合格，20-初审不合格，27-初审暂缓注册，14-初审不在注册范围，24-初审材料不全，28-初审无教师资格
//    复核状态：19-复核合格，20-复核不合格，27-复核暂缓注册，14-复核不在注册范围，28-复核无教师资格
//    终审状态：19-注册合格，20-注册不合格，27-暂缓注册，14-终审不在注册范围，28-终审无教师资格
export const confirmList = [
  {dicId: "19", name: "初审合格"},
  {dicId: "20", name: "初审不合格"},
  {dicId: "27", name: "初审暂缓注册"},
  {dicId: "14", name: "初审不在注册范围"},
  {dicId: "24", name: "初审材料不全"},
  {dicId: "28", name: "初审无教师资格"}
]

export const reCheckList = [
  {dicId: "19", name: "复核合格"},
  {dicId: "20", name: "复核不合格"},
  {dicId: "27", name: "复核暂缓注册"},
  {dicId: "14", name: "复核不在注册范围"},
  {dicId: "28", name: "复核无教师资格"}
]


export const judgmintList = [
  {dicId: "19", name: "注册合格"},
  {dicId: "20", name: "注册不合格"},
  {dicId: "27", name: "暂缓注册"},
  {dicId: "14", name: "终审不在注册范围"},
  {dicId: "28", name: "终审无教师资格"}
]


export const enrollNumList = [
  {dicId: "1", name: "第1次注册"},
  {dicId: "2", name: "第2次注册"},
  {dicId: "3", name: "第3次注册"},
  {dicId: "4", name: "第4次注册"},
  {dicId: "5", name: "第5次注册"},
  {dicId: "6", name: "第6次注册"},
  {dicId: "7", name: "第7次注册"},
  {dicId: "8", name: "第8次注册"},
  {dicId: "9", name: "第9次注册"},
  {dicId: "10", name: "第10次注册"}
]

//学校性质
export const xxxzList = [
  {dicId: "305", name: "公办幼儿园"},
  {dicId: "306", name: "公办小学"},
  {dicId: "307", name: "公办初中"},
  {dicId: "308", name: "公办高中"},
  {dicId: "309", name: "公办中职中专（技校）"},
  {dicId: "310", name: "少年宫、地方教研室、电化教育机构"},
  {dicId: "321", name: "公办完全中学（含初中、高中）"},
  {dicId: "311", name: "民办幼儿园"},
  {dicId: "312", name: "民办小学"},
  {dicId: "313", name: "民办小学"},
  {dicId: "314", name: "民办高中"},
  {dicId: "315", name: "民办中职中专（技校）"},
  {dicId: "322", name: "民办完全中学（含初中、高中）"},
  {dicId: "403", name: "特殊教育学校"},
  {dicId: "323", name: "公办九年一贯制学校（含小学、初中）"},
  {dicId: "324", name: "公办十二年一贯制学校(含小学、初中、高中)"},
  {dicId: "401", name: "民办九年一贯制学校（含小学、初中）"},
  {dicId: "402", name: "民办十二年一贯制学校(含小学、初中、高中)"},
  {dicId: "444", name: "测试外键-学校性质redis"}
]


export const graduateIdList=[
  { dicId: "2", name: "否" },
  { dicId: "1", name: "是" }
]

export const allowQueryList=[
  { dicId: "0", name: "未提供证书验证" },
  { dicId: "1", name: "已提供证书验证" }
]

export const isReadList = [
  { dicId: "0", name: "否" },
  { dicId: "1", name: "是" }
]


export const ecertTaskStatus = [
  { dicId: "0", name: "待执行" },
  { dicId: "2", name: "执行中" },
  { dicId: "1", name: "任务完成" }
]

export const materials = [
  { dicId: "2", name: "材料待完善" },
  { dicId: "1", name: "材料合格" }
]

export const enrollNumType= [
  { dicId: "1", name: "首次注册" },
  { dicId: "2", name: "非首次注册" }
]

export const areaType = [
  { dicId: "81", name: "香港" },
  { dicId: "82", name: "澳门" },
  { dicId: "83", name: "台湾" }
]

export const normalType = [
  { dicId: "公费师范生", name: "公费师范生" },
  { dicId: "普通师范生", name: "普通师范生" },
  { dicId: "优师计划师范生", name: "优师计划师范生" },
  { dicId: "教育类研究生", name: "教育类研究生" }
]
// 公费师范生、优师计划师范生、普通师范生、教育类研究生
//   * 0 未上报
// * 1 待审核
// * 2 审核通过
// * 3 审核不通过
// * 4 已锁定
export const normalAudStatus = [
  { dicId: "0", name: "未上报" },
  { dicId: "1", name: "待审核" },
  { dicId: "2", name: "审核通过" },
  { dicId: "3", name: "审核不通过" },
  { dicId: "4", name: "已锁定" }
]
//   * 0 正常
// * 1 无效
// * 2 删除
export const normalDataStatus = [
  { dicId: "0", name: "正常" },
  { dicId: "1", name: "无效" },
  { dicId: "2", name: "删除" }
]

export const queryViewBaseDictByDictType = (that, params) => {
  return new Promise((resolve, reject) => {
    const uri = "viewBaseDictByDictType";
    that.$json(uri, params).then(response => {
      resolve(response.record);
    });
  });
};


export const roles =(that, params) => {
  return new Promise((resolve, reject) => {
    const uri = "queryRole";
    that.$json(uri, params)
      .then(response => {
        // this.options.roles= response.data.record;
        resolve( response.record);
      })
  });
};


// // 注册确认点
// export const queryBaseOrgBasicList = (that,params) => {
//   return new Promise((resolve, reject) => {
//     const uri = "queryBaseOrgBasic";
//     that.$json(uri, params).then(response => {
//       resolve(response.record);
//     });
//   });
// };


export const CmdbAttributeDictValue = (that, params) => {
  return new Promise((resolve, reject) => {
    const uri = "viewBaseDictByDictType";
    that.$json(uri, params).then(response => {
      resolve(response.record);
    });
  });
};


export const getReportDictData = (params) => {
  return new Promise((resolve, reject) => {
    request("getReportDictData", params).then(res => {
      const {code, message, data} = res.data;
      if (code) {
        Message.error(message);
        return;
      }
      resolve(data);
    });
  });
};


export const getRoleList = (that) => {
  return new Promise((resolve, reject) => {
    const uri = "queryRole";
    const params = {};
    that.$json(uri, params).then(response => {
      resolve(response.record);

      // let data=response.record;
      // this.total=response.total
      // this.data=data
    });
    // ("getSchoolType").then(res => {
    //   const { code, message, data } = res.data;
    //   if (code) {
    //     Message.error(message);
    //     return;
    //   }
    //   resolve(data.result);
    // });
  });
};


export const getLocalSetList = (that) => {
  return new Promise((resolve, reject) => {
    const params = {};
    const uri = "queryBaseOrgBasic";
    params["isQueryConfirmUser"] = 1;
    params["orgBizType"] = 1;
    params["orgType"] = 1;
    params["parentId"] = JSON.parse(
      sessionStorage.getItem("unInfo")
    ).user.orgId; //登录机构id
    that.$json(uri, params)
      .then(response => {
        let localList = response.record;
        if (localList) {
          localList.map((item) => {
            item.name = item.orgName
            item.dicId = item.orgId
          })
        }
        resolve(localList);
        /*this.total = response.total;*/
      })
      .catch(e => {
        that.$message.error(e.message);
      });
  });
};


export const getEnrollLocalSetList = (that) => {
  return new Promise((resolve, reject) => {
    const params = {};
    const uri = "queryBaseOrgBasic";
    params["isQueryConfirmUser"] = 1;
    params["orgBizType"] = 2;
    params["orgType"] = 1;
    params["parentId"] = JSON.parse(
      sessionStorage.getItem("unInfo")
    ).user.orgId; //登录机构id
    that.$json(uri, params)
      .then(response => {
        let localList = response.record;
        if (localList) {
          localList.map((item) => {
            item.name = item.orgName
            item.dicId = item.orgId
          })
        }
        resolve(localList);
        /*this.total = response.total;*/
      })
      .catch(e => {
        that.$message.error(e.message);
      });
  });
};

export const obtList = (that) => {

  return new Promise((resolve, reject) => {
    // that.$json("getCurrentOrgBatchTimesxx", {})
    that.$json("queryOrgBatchTimexx", {isQuy:1,type:1})
      .then(response => {
        let obtList1 = response.record;
        if (obtList1) {
          obtList1.map((item) => {
            if (item.endStr != null) {
              item.name = item.beginStr + "至" + item.endStr
            } else {

               item.name = item.beginStr
            }
            item.dicId = item.obtId
          })
        }
        resolve(obtList1);
        /*this.total = response.total;*/
      })
      .catch(e => {
        that.$message.error(e.message);
      });
  });
};











// WEBPACK FOOTER //
// ./src/config/typeConfig.js